import { useState } from 'react';

import { CarUseResultInfoType } from '../../feature/type/CarUseResultInfoType';

/**
 * 車両利用実績一覧の状態管理用カスタムフック
 */
export const useStateCarUseResult = () => {
	const [carUseResultInfoList, setCarUseResultInfoList] = useState<CarUseResultInfoType[]>([]); // 取得した車両利用実績一覧の管理

	return {
		carUseResultInfoList,
		setCarUseResultInfoList,
	};
};
